module.exports = __webpack_public_path__ + "img/3.7318e843.png";